import ExceptionCode from '@/Enums/Exceptions/ExceptionCode.enum';
import { IApiException } from '@/Interfaces/ApiResponse/ApiException.interface';

export const isCreativeAssociationException = (error: IApiException): boolean =>
  error?.code === ExceptionCode.CreativeAssociation;
